export default "data:image/svg+xml,This%20attachment%20was%20removed%20because%20it%20contains%20data%20that%20could%20pose%20a%20security%20risk."